// sortKeys: list of stat indexes to compare scores
export const sortKarts = (karts, sortKeys) => {
  if (!sortKeys.length) {
    return karts;
  }

  // Copy sortKeys since compareKarts mutates the array.
  return karts.sort((k1, k2) => compareKarts(k1, k2, sortKeys.slice()));
};

const compareKarts = (kart1, kart2, sortKeys) => {
  if (!sortKeys.length) {
    return 0;
  }

  const sortKey = sortKeys.shift();

  const val1 = kart1.stats[sortKey];
  const val2 = kart2.stats[sortKey];

  if (val1 === val2) {
    return compareKarts(kart1, kart2, sortKeys);
  }

  return val1 > val2 ? -1 : 1; // sort descending
};
